import { Box, Tab, Tabs } from '@mui/material';
import { SyntheticEvent, useState } from 'react';
import {
  CUSTOMER_SETTINGS_TAB_ACCOUNT_DETAILS,
  LABEL_SECURITY_CODE_PIN,
  MENU_ITEM_ACCOUNT_SETTINGS,
  PAGE_TITLE_BILLING_ADDRESS_SECTION
} from '../../../../../shared/lib/constants';
import { tabsSticky, tabsWrapper } from '../../../../../shared/lib/theme/styleConstants';
import { BillingAddress } from '../../../components/billingAddress/BillingAddress';
import { AccountDetails } from '../../../components/accountSettings/AccountDetails';
import { PageHeading } from '../../../../../shared/lib/common/PageHeading';
import { TabPanel } from '../../../../../shared/lib/common/Tabpanel';
import { DashboardContainer } from '../../../components/dashboard/DashboardContainer';
import { SecurityCode } from '../../../components/securityCode/SecurityCode';
import { handleTabs } from '../../utils';
import { useAppContext } from '../../contexts/AppContext';
import { ActionType } from '../../reducer/AppContextReducer';

const AccountSettings = () => {
  const [value, setValue] = useState(0);
  const { dispatch } = useAppContext();

  const handleChange = (_event: SyntheticEvent, newValue: number) => {
    dispatch({ type: ActionType.SET_CURRENT_PAGE, currentPage: 1 });
    setValue(newValue);
  };

  return (
    <>
      <DashboardContainer>
        <PageHeading color="blackOne" title={MENU_ITEM_ACCOUNT_SETTINGS} subTitle="" />

        <Box sx={tabsWrapper}>
          <Box sx={tabsSticky}>
            <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
              <Tab sx={{ textTransform: 'none' }} label={CUSTOMER_SETTINGS_TAB_ACCOUNT_DETAILS} {...handleTabs(0)} />

              <Tab sx={{ textTransform: 'none' }} label={LABEL_SECURITY_CODE_PIN} {...handleTabs(1)} />

              <Tab sx={{ textTransform: 'none' }} label={PAGE_TITLE_BILLING_ADDRESS_SECTION} {...handleTabs(2)} />
            </Tabs>
          </Box>

          <TabPanel value={value} index={0}>
            <AccountDetails />
          </TabPanel>

          <TabPanel value={value} index={1}>
            <SecurityCode />
          </TabPanel>

          <TabPanel value={value} index={2}>
            <BillingAddress />
          </TabPanel>
        </Box>
      </DashboardContainer>
    </>
  );
};

export default AccountSettings;
